import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { FileDownloadOutlined } from '@mui/icons-material';

export const ImportButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<FileDownloadOutlined />} {...props}>
      {children ?? t('ImportData')}
    </Button>
  );
};
